import { render, staticRenderFns } from "./ExpensesChart.vue?vue&type=template&id=37bb0104"
import script from "./ExpensesChart.vue?vue&type=script&lang=js"
export * from "./ExpensesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports